import { useEffect, useState } from 'react'

import { useBootSplashGone } from '@/lib/bootSplash'

/** Just past the last card settling (measured ~0.92s), so what follows lands a beat after it. */
const CASCADE_MS = 1200

export type QuotesCascadePhase = 'waiting' | 'on' | 'done'

/**
 * The quotes page's entrance, for its root's data-cascade: held hidden until the boot splash has
 * gone and the page is ready, played once, then switched off so re-sorted cards don't replay it.
 */
export function useQuotesCascade(ready: boolean): QuotesCascadePhase {
  const splashGone = useBootSplashGone()
  const [done, setDone] = useState(false)
  const playing = ready && splashGone

  useEffect(() => {
    if (!playing) return
    const timer = window.setTimeout(() => setDone(true), CASCADE_MS)
    return () => window.clearTimeout(timer)
  }, [playing])

  if (done) return 'done'
  return playing ? 'on' : 'waiting'
}
